module.exports = __webpack_public_path__ + "img/background_modal.0d030dd9.jpg";